export default __webpack_public_path__ + "static/media/stripes2.3d0b3aa3.jpg";